import { useState } from "react";
import Customer_write from "./Customer_write";
import CustomModal from "@/components/modal/CustomModal";
import { cn } from "@/utils/cn";
import type * as type from "@vTypes";
import { useNoticeList } from "@/hooks/useNoticeList";
import LoadingSpiner from "@/components/ui/LoadingSpiner";
import { NoticeItem } from "./NoticeItem";

export default function Customer_notice({
  writeQuestion,
}: {
  writeQuestion: (payload: type.QuestionPayload) => void;
}) {
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);
  const [openedNoticeId, setOpenedNoticeId] = useState<number | null>(null);

  // 공지사항 목록 조회
  const { data: noticeListData, isPending } = useNoticeList(1, 10);
  const noticeList = noticeListData?.items ?? [];

  function toggleNotice(id: number) {
    if (openedNoticeId === id) {
      setOpenedNoticeId(null);
    } else {
      setOpenedNoticeId(id);
    }
  }

  return (
    <div className="customerSection min-h-[600px]">
      <div className="flex justify-between items-center mb-5">
        <div className="text-2xl font-semibold">공지사항</div>
      </div>

      {/* 헤더 */}
      <div className="grid grid-cols-[60px_585px_120px_50px] gap-x-2.5 border border-transparent border-b-[#D6D6DE] border-t-[#D6D6DE] bg-[#F2F2F2] text-center text-[#808080]">
        <div className="text-[15px] leading-10">번호</div>
        <div className="text-[15px] leading-10">제목</div>
        <div className="text-[15px] leading-10">작성일</div>
        <div className="text-[15px] leading-10"></div>
      </div>

      {isPending ? (
        <div className="flex flex-col items-center justify-center min-h-[280px] py-12">
          <LoadingSpiner msg="공지사항을 불러오는 중입니다" />
        </div>
      ) : noticeList.length ? (
        <div className="w-full">
          {noticeList.map((item, index) => (
            <NoticeItem
              key={item.id}
              item={item}
              index={index}
              isOpen={openedNoticeId === item.id}
              onToggle={() => toggleNotice(item.id)}
            />
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-400 mt-10 text-[15px] leading-10">
          공지사항이 없습니다.
        </div>
      )}

      {isInquiryModalOpen ? (
        <CustomModal.Panel
          onClose={() => setIsInquiryModalOpen(false)}
          dismissOnOverlay
          className={cn(
            "w-[min(560px,calc(100vw-48px))] max-w-[640px] bg-white",
            "border border-[#D6D6DE] shadow-lg",
            "[&>div]:!p-0 [&>div]:overflow-y-auto"
          )}
        >
          <div className="p-7">
            <Customer_write
              writeQuestion={(payload) => {
                writeQuestion(payload);
                setIsInquiryModalOpen(false);
              }}
              onCancel={() => setIsInquiryModalOpen(false)}
            />
          </div>
        </CustomModal.Panel>
      ) : null}
    </div>
  );
}
